import React from 'react';
import Icon from '@pushpay/icon';

const SettingsIcon = props => {
  return /*#__PURE__*/React.createElement(Icon, Object.assign({
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M20.684 10.135l-1.055-.375a1.144 1.144 0 01-.65-1.571l.48-1.011a1.98 1.98 0 00-2.637-2.637l-1.011.48a1.147 1.147 0 01-1.571-.651l-.375-1.054a1.98 1.98 0 00-3.73 0L9.76 4.37a1.146 1.146 0 01-1.57.65l-1.012-.48a1.98 1.98 0 00-2.637 2.637l.48 1.01a1.145 1.145 0 01-.65 1.572l-1.055.375a1.979 1.979 0 000 3.73l1.055.375a1.145 1.145 0 01.65 1.57l-.48 1.011a1.98 1.98 0 002.637 2.638l1.011-.48a1.144 1.144 0 011.571.65l.375 1.055a1.98 1.98 0 003.73 0l.375-1.055a1.145 1.145 0 011.57-.65l1.012.48a1.98 1.98 0 002.637-2.638l-.48-1.01a1.145 1.145 0 01.65-1.571l1.055-.376a1.979 1.979 0 000-3.73zM12 15.986a4.108 4.108 0 01-3.7-2.453 4.01 4.01 0 012.166-5.234 4.057 4.057 0 015.234 2.166 4.01 4.01 0 01-2.167 5.235c-.486.2-1.008.297-1.533.286z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

export default SettingsIcon;